export const SBK_BLUE = "rgb(0, 60, 110)";
